import { useLocale } from '../hooks/useLocale'
import styles from './LanguageSelector.module.css'

export default function LanguageSelector() {
  const { locale, setLocale } = useLocale()

  return (
    <div className={styles.selector}>
      <button
        className={`${styles.button} ${locale === 'es' ? styles.active : ''}`}
        onClick={() => setLocale('es')}
        aria-label="Cambiar a español"
        aria-pressed={locale === 'es'}
      >
        ES
      </button>
      <span className={styles.separator}>|</span>
      <button
        className={`${styles.button} ${locale === 'en' ? styles.active : ''}`}
        onClick={() => setLocale('en')}
        aria-label="Switch to English"
        aria-pressed={locale === 'en'}
      >
        EN
      </button>
    </div>
  )
}
